import React from 'react';
import styled from 'styled-components';

import Container from 'partials/Container';
import GridElement from 'partials/GridElement';
import Image from 'partials/Image';
import SmartLink from 'partials/SmartLink';
import IconSelector from 'partials/IconSelector';

import Media from 'css/Media';

export const GreenBoxLink = props => {

    const { data, last } = props;
    return (
        <Wrapper last={last}>
            <Container grid mobileBleed>
                <StyledGridElement
                    colStart={{default: 1, s: 7}}
                    colEnd={{default: 8, s: 18}}
                >
                <InnerGrid>
                    <GridElement
                        colStart={{default: 1, s: 1}}
                        colEnd={{default: 8, s: 10}}
                        rowStart={1}
                    >
                        <SmartLink to={data.link.url}>
                            <ImageOverlay>
                                <Image image={data.image} />
                            </ImageOverlay>
                        </SmartLink>
                    </GridElement>   
                    <GridElement
                        colStart={{default: 1, s: 1}}
                        colEnd={{default: 8, s: 10}}
                        rowStart={2}
                    >
                        <SmartLink to={data.link.url}>
                            <h2>{data.title}</h2>
                        </SmartLink>
                    </GridElement>
                    <DescriptionGridElement
                        colStart={{default: 1, s: 1}}
                        colEnd={{default: 8, s: 10}}
                        rowStart={3}
                    >
                        <span>{data.description}</span>
                    </DescriptionGridElement>
                    <ButtonGridElement
                        colStart={{default: 1, s: 1}}
                        colEnd={{default: 8, s: 10}}
                        rowStart={4}
                    >
                        <SmartLink to={data.link.url}>
                            <IconSelector icon={data.icon} />
                            <span>{data.link.title}</span>
                            </SmartLink>
                    </ButtonGridElement>
                </InnerGrid>
                </StyledGridElement>
            </Container>
        </Wrapper>
    )
}

export default GreenBoxLink;

const Wrapper = styled.div`
    margin-bottom: ${props => props.last ? 0 : props.theme.spacing.blockXS};

    ${Media.greaterThan('s')`
        margin-bottom: ${props => props.last ? 0 : props.theme.spacing.blockXL};
    `}
`

const StyledGridElement = styled(GridElement)`
    background: ${props => props.theme.colors.bg};
    padding-bottom: ${props => props.theme.spacing.elementS};

    a {
        cursor: pointer;
    }
    
    ${Media.greaterThan('s')`
        padding-bottom: 0;
    `}
`

const InnerGrid = styled.div`
    display: -ms-grid;
    display: grid;
    -ms-grid-columns: (1fr .33fr)[3] 1fr;
    grid-template-columns: repeat(3, 1fr .33fr) 1fr;
    padding-bottom: ${props => props.theme.spacing.elementM};
    
    h2 {
        ${props => props.theme.fonts.h3}
        padding: 0 25px ${props => props.theme.spacing.contentL};
    }
    
    ${Media.greaterThan('s')`
        -ms-grid-columns: (1fr .435fr)[5] 1fr;
        grid-template-columns: repeat(5, 1fr .435fr) 1fr;
        padding-bottom: ${props => props.theme.spacing.blockXS};
        
        h2 {
            padding: 0 ${props => props.theme.spacing.elementXS} ${props => props.theme.spacing.contentL};
        }
    `}
`

const ImageOverlay = styled.div`
    cursor: pointer;
    margin-bottom: ${props => props.theme.spacing.contentXL};

    &::after {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        content: '';
        background-color: transparent;
        transition: all .2s ease-in;
    }

    &:hover {
        &::after {
            background-color: rgba(0, 0, 0, .2);
        }
    }
`

const InnerGridElement = styled(GridElement)`
    padding: 0 25px;

    span {
        ${props => props.theme.fonts.p}
        
        ${Media.greaterThan('s')`
            font-size: 18px;
            line-height: 27px;
        `}
    }

    a {
        text-decoration: underline;
        
        &:hover {
            text-decoration: none;
        }
    }
    
    ${Media.greaterThan('s')`
        padding: 0 ${props => props.theme.spacing.elementXS};
    `}
`

const DescriptionGridElement = styled(InnerGridElement)`
    margin-bottom: ${props => props.theme.spacing.contentXL};
`

const ButtonGridElement = styled(InnerGridElement)`
    a {
        display: flex;
        align-items: center;
    }
`